export enum ObjectCategories {
    Landslide,
    EndangeredArea,
    Protocol
    
}